import {Injectable} from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Http} from '@angular/http';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
import {RiderPayorInterface} from '../interfaces/rider-payor.interface';
import {map} from 'rxjs/operators';

@Injectable()
export class RiderPayorService extends ParentService {

  constructor(private _http: Http) {
    super();
  }

  /**
   *  http://localhost:33889/Rest/RiderPayor/Create POST
   * http://localhost:33889/Rest/RiderPayor/Update PUT
   * http://localhost:33889/Rest/RiderPayor/{riderpayorid} GET
   * http://localhost:33889/Rest/RiderPayor/1019402 Delete
   * ttp://localhost:33889/Rest/RiderPayor?riderId=4 GET
   */

  get (id: number): Observable<RiderPayorInterface[]> {
    return this._http.get(`${constant.RIDER.RIDER_PAYOR.GET + id}`, this.getHeader())
      .pipe(
        map((response: any) => response.json() as RiderPayorInterface[])
      ).catch((error: any) => Observable.throw(error.json()));
  }

  post (riderPayor: RiderPayorInterface) {
    const body = JSON.stringify(riderPayor);
    return this._http.post(`${constant.RIDER.RIDER_PAYOR.POST}`, body, this.headerPost())
      .pipe(
        map((response: any) => response.json())
      ).catch((error: any) => Observable.throw(error.json()));
  }

  put (riderPayor: RiderPayorInterface) {
    const body = JSON.stringify(riderPayor);
    return this._http.put(`${constant.RIDER.RIDER_PAYOR.PUT}`, body, this.headerPost())
      .pipe(
        map((response: any) => response.json())
      ).catch((error: any) => Observable.throw(error.json()));
  }

  delete (id: number) {
    return this._http.delete(`${constant.RIDER.RIDER_PAYOR.BASE + id}`, this.headerPost())
      .pipe(
        map((response: any) => response.json() as RiderPayorInterface[])
      ).catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/rider-payor.service.ts